module.exports = __webpack_public_path__ + "img/08-full.e1dc9dd1.jpeg";